import { render, staticRenderFns } from "./TeamLoginController.vue?vue&type=template&id=584c60ce&scoped=true"
import script from "./TeamLoginController.vue?vue&type=script&lang=ts"
export * from "./TeamLoginController.vue?vue&type=script&lang=ts"
import style0 from "./TeamLoginController.vue?vue&type=style&index=0&id=584c60ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c60ce",
  null
  
)

export default component.exports